/**
 * Where the order stands in the company's numbers (mockup stage tag): drafts and
 * offers are outside the forecast, a confirmed order is in it, an invoiced one
 * is in the company result.
 */
export const getOrderMarginCardStage = (status: string | null | undefined, settledBySettlementInvoice = false): 'before' | 'forecast' | 'result' => {
  // A settlement invoice puts the ZK in the company result while the warehouse
  // still delivers it; an advance alone does not (decision 2026-11-02-zaliczka-bez-przychodu.md).
  if (status === 'INVOICED' || settledBySettlementInvoice) return 'result';
  if (status === 'NEW_INQUIRY' || status === 'QUOTE_SENT') return 'before';
  return 'forecast';
};
